import styled from 'styled-components'

export const Scrollable = styled.div`
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    display: none;
  }
`
